import { ProductCarouselData } from "./homepage.module"
import * as i18n from "tb-i18n"
import { getRegisterUrl } from "../utils"
// hero video component
const config = require("json-loader!yaml-loader!../../../config/default.yaml")

export { getRegisterUrl }

export const getCustomerCaseUrl = () =>
    `${config.BLOG_CASE_HOST}/?utm_content=homepage`

export interface VideoData {
    poster: any
    src: string
}

export const getVideoData = (): VideoData => {
    return {
        poster: require("../images/homepage/hero-video-poster.png"),
        src: "http://dn-site.teambition.net/videos/teambition_commercial_zh.mp4"
    }
}

// 首屏下部分产品轮播
export interface ProductCarouselData {
    image: string
    title: string
    subtitle: string
    button: string
    link: string
    isNew: boolean
}
export const getProductCarouselData = () => {
    return [
        // {
        //   image: require('../images/homepage/product-carousel-0.jpg'),
        //   title: i18n.get('homepage.productCarousel.0.title'),
        //   subtitle: i18n.get('homepage.productCarousel.0.subtitle'),
        //   button: i18n.get('homepage.productCarousel.0.button'),
        //   link: getTrialUrl(true),
        //   isNew: true
        // },
        {
            image: require("../images/homepage/product-carousel-2.jpg"),
            title: i18n.get("homepage.productCarousel.2.title"),
            subtitle: i18n.get("homepage.productCarousel.2.subtitle"),
            button: i18n.get("homepage.productCarousel.2.button"),
            link: `${
                config.BLOG_HOST
                }/DevOps?utm_content=homepage&utm_term=dev`,
            isNew: true
        }
    ] as ProductCarouselData[]
}

// 三个主产品矩阵
export interface ProductsMatrixDataType {
    fontImage: string
    enFontImage: string
    themeColor?: string
    backgroundLinear: [string, string]
    icon: string
    title: string
    subtitle: string
    isWIP: boolean
    link?: string
}
export const getProductsMatrixData = () => {
    return [
        {
            fontImage: require("../images/homepage/product-matrix-teambition.png"),
            enFontImage: require("../images/homepage/product-matrix-teambition-en.png"),
            backgroundLinear: ["#cdeefc", "#9dd0f5"],
            icon: require("../images/icon-teambition.svg"),
            title: i18n.get("homepage.productsMatrix.0.title"),
            subtitle: i18n.get("homepage.productsMatrix.0.subtitle"),
            themeColor: "#3DA8F5",
            link: "/tour?utm_content=homepage",
            isWIP: false
        },
        {
            fontImage: require("../images/homepage/product-matrix-thoughts.png"),
            enFontImage: require("../images/homepage/product-matrix-thoughts-en.png"),
            backgroundLinear: ["#cdeefc", "#CCCFFF"],
            icon: require("../images/icon-thoughts.svg"),
            title: i18n.get("homepage.productsMatrix.1.title"),
            subtitle: i18n.get("homepage.productsMatrix.1.subtitle"),
            themeColor: "#797EC9",
            link: "https://suosi.teambition.net/?utm_content=tb_homepage",
            isWIP: false
        },
        {
            fontImage: require("../images/homepage/product-matrix-bingo.png"),
            enFontImage: require("../images/homepage/product-matrix-bingo-en.png"),
            backgroundLinear: ["#cdeefc", "#FAEABB"],
            icon: require("../images/icon-bingo.svg"),
            title: i18n.get("homepage.productsMatrix.2.title"),
            subtitle: i18n.get("homepage.productsMatrix.2.subtitle"),
            isWIP: true
        }
    ] as ProductsMatrixDataType[]
}

// 项目类型卡片墙
interface ProjectTypeDataType {
    icon: string
    title: string
    detail: string
    link: string
}
export const getProjectTypeData = () => {
    // todo: replace icon
    return [
        {
            icon: require("../images/homepage/project-type.0.svg"),
            title: i18n.get("homepage.project.type.0.title"),
            detail: i18n.get("homepage.project.type.0.detail"),
            link: "/solution"
        },
        {
            icon: require("../images/homepage/project-type.1.svg"),
            title: i18n.get("homepage.project.type.1.title"),
            detail: i18n.get("homepage.project.type.1.detail"),
            link: "/manageproject?utm_content=homepage"
        },
        {
            icon: require("../images/homepage/project-type.2.svg"),
            title: i18n.get("homepage.project.type.2.title"),
            detail: i18n.get("homepage.project.type.2.detail"),
            link: "/agile?utm_content=homepage"
        },
        {
            icon: require("../images/homepage/project-type.3.svg"),
            title: i18n.get("homepage.project.type.3.title"),
            detail: i18n.get("homepage.project.type.3.detail"),
            link: "/pm?utm_content=homepage"
        },
        {
            icon: require("../images/homepage/project-type.4.svg"),
            title: i18n.get("homepage.project.type.4.title"),
            detail: i18n.get("homepage.project.type.4.detail"),
            link: "/marketing?utm_content=homepage"
        },
        {
            icon: require("../images/homepage/project-type.5.svg"),
            title: i18n.get("homepage.project.type.5.title"),
            detail: i18n.get("homepage.project.type.5.detail"),
            link: "/hr?utm_content=homepage"
        }
    ] as ProjectTypeDataType[]
}

// 客户墙轮播
export interface CustomerCarouselDataType {
    name: string
    image: string
    logo: string
    describe: string
    link: string
}
export const getCustomerCarouselData = () => {
    // todo: resource
    return [
        {
            name: "dedao",
            image: require("../images/homepage/customer-image-dedao.jpg"),
            logo: require("../images/homepage/customer-logo-dedao.jpg"),
            describe: i18n.get("homepage.customer.5.describe"),
            link: `${
                config.BLOG_CASE_HOST
                }/details/5c207658efb0c602f2d1cad5?utm_content=homepage`
        },
        {
            name: "xiaomi",
            image: require("../images/homepage/customer-image-xiaomi.jpg"),
            logo: require("../images/homepage/customer-logo-xiaomi.jpg"),
            describe: i18n.get("homepage.customer.4.describe"),
            link: `${
                config.BLOG_CASE_HOST
                }/details/5c207c60efb0c602f2d1cadf?utm_content=homepage`
        },
        {
            name: "ximalaya",
            image: require("../images/homepage/customer-image-ximalaya.jpg"),
            logo: require("../images/homepage/customer-logo-ximalaya.jpg"),
            describe: i18n.get("homepage.customer.0.describe"),
            link: `${
                config.BLOG_CASE_HOST
                }/details/5c20abfff4640f66bd8af01b?utm_content=homepage`
        },
        {
            name: "yonghui",
            image: require("../images/homepage/customer-image-yonghui.jpg"),
            logo: require("../images/homepage/customer-logo-yonghui.jpg"),
            describe: i18n.get("homepage.customer.3.describe"),
            link: `${
                config.BLOG_CASE_HOST
                }/details/5c209032efb0c602f2d1cae6?utm_content=homepage`
        },
        {
            name: "antai",
            image: require("../images/homepage/customer-image-antai.jpg"),
            logo: require("../images/homepage/customer-logo-antai.jpg"),
            describe: i18n.get("homepage.customer.2.describe"),
            link: `${
                config.BLOG_CASE_HOST
                }/details/5c0dfa1563f6625f7d2c5259?utm_content=homepage`
        },
        {
            name: "kaishu",
            image: require("../images/homepage/customer-image-kaishu.jpg"),
            logo: require("../images/homepage/customer-logo-kaishu.jpg"),
            describe: i18n.get("homepage.customer.1.describe"),
            link: `${
                config.BLOG_CASE_HOST
                }/details/5c077497fac6f561d8b1261e?utm_content=homepage`
        }
    ] as CustomerCarouselDataType[]
}

interface CustomerWallLogoType {
    src: string
}

export const getCustomerWallData = () => {
    return [
        {
            src: require("../images/homepage/logowall-0.png")
        },
        {
            src: require("../images/homepage/logowall-1.png")
        },
        {
            src: require("../images/homepage/logowall-2.png")
        },
        {
            src: require("../images/homepage/logowall-3.png")
        },
        {
            src: require("../images/homepage/logowall-4.png")
        },
        {
            src: require("../images/homepage/logowall-5.png")
        },
        {
            src: require("../images/homepage/logowall-6.png")
        },
        {
            src: require("../images/homepage/logowall-7.png")
        },
        {
            src: require("../images/homepage/logowall-8.png")
        },
        {
            src: require("../images/homepage/logowall-9.png")
        },
        {
            src: require("../images/homepage/logowall-10.png")
        },
        {
            src: require("../images/homepage/logowall-11.png")
        }
    ] as CustomerWallLogoType[]
}

// guide steps components
export interface GuideStepsData {
    step: number
    title: string
}

export const getGuideStepsData = () => {
    return [
        {
            step: 1,
            title: i18n.get("homepage.guide.step.1.title")
        },
        {
            step: 2,
            title: i18n.get("homepage.guide.step.2.title")
        },
        {
            step: 3,
            title: i18n.get("homepage.guide.step.3.title")
        }
    ] as GuideStepsData[]
}
